import {createContext, useContext} from 'react';

/** Pan offset (world units) applied inside each detail Layer scene. */
export const DetailViewTransformContext = createContext({x: 0, y: 0});

export const useDetailViewTransform = () => useContext(DetailViewTransformContext);
